import { api, API_BASE_URL } from './api'

export const blogService = {
    adminList: () => api.get('/blogs/admin/all'),
    adminGet: (id) => api.get(`/blogs/admin/${id}`),
    create: (data) => api.post('/blogs', data),
    update: (id, data) => api.put(`/blogs/${id}`, data),
    delete: (id) => api.delete(`/blogs/${id}`),

    uploadCoverImage: async (file) => {
        const formData = new FormData()
        formData.append('file', file)
        const token = localStorage.getItem('admin_token')
        const res = await fetch(`${API_BASE_URL}/blogs/admin/upload-image`, {
            method: 'POST',
            headers: token ? { Authorization: `Bearer ${token}` } : {},
            body: formData,
        })
        if (!res.ok) {
            const err = await res.json().catch(() => ({ message: 'Upload failed' }))
            throw new Error(err.message || `HTTP ${res.status}`)
        }
        return res.json()
    },

    parseDocument: async (file) => {
        const formData = new FormData()
        formData.append('file', file)
        const token = localStorage.getItem('admin_token')
        const res = await fetch(`${API_BASE_URL}/blogs/admin/parse-document`, {
            method: 'POST',
            headers: token ? { Authorization: `Bearer ${token}` } : {},
            body: formData,
        })
        if (!res.ok) {
            const err = await res.json().catch(() => ({ message: 'Upload failed' }))
            throw new Error(err.message || `HTTP ${res.status}`)
        }
        return res.json()
    },
}
